import { Helmet } from 'react-helmet-async';
import { websiteSchema } from '@/config/structuredData';

// Define a generic Schema type that can represent any valid JSON-LD object or array of objects.
export type SchemaObject = {
  '@context': string;
  '@type': string;
  [key: string]: any;
};

export type Schema = SchemaObject | SchemaObject[];

interface StructuredDataProps {
  // The schema prop is now optional. If not provided, the component will use a default.
  schema?: Schema;
}

/**
 * Renders a JSON-LD script tag for structured data inside a Helmet component.
 * It will render the schema passed via props, or a default website schema if none is provided.
 */
const StructuredData = ({ schema }: StructuredDataProps) => {
  const finalSchema = schema || websiteSchema;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
